// src/app/redux/actions/candidatsActions.js
export const SET_CANDIDATS_LOADING = "SET_CANDIDATS_LOADING";
export const SET_CANDIDATS_ERROR = "SET_CANDIDATS_ERROR";

export const FETCH_CANDIDATS_REQUEST = "FETCH_CANDIDATS_REQUEST";
export const FETCH_CANDIDATS_SUCCESS = "FETCH_CANDIDATS_SUCCESS";
export const FETCH_CANDIDATS_FAIL = "FETCH_CANDIDATS_FAIL";

export const CREATE_CANDIDAT_REQUEST = "CREATE_CANDIDAT_REQUEST";
export const CREATE_CANDIDAT_SUCCESS = "CREATE_CANDIDAT_SUCCESS";
export const CREATE_CANDIDAT_FAIL = "CREATE_CANDIDAT_FAIL";

export const UPDATE_CANDIDAT_REQUEST = "UPDATE_CANDIDAT_REQUEST";
export const UPDATE_CANDIDAT_SUCCESS = "UPDATE_CANDIDAT_SUCCESS";
export const UPDATE_CANDIDAT_FAIL = "UPDATE_CANDIDAT_FAIL";

export const DELETE_CANDIDAT_REQUEST = "DELETE_CANDIDAT_REQUEST";
export const DELETE_CANDIDAT_SUCCESS = "DELETE_CANDIDAT_SUCCESS";
export const DELETE_CANDIDAT_FAIL = "DELETE_CANDIDAT_FAIL";

export const setCandidatsLoading = (v) => ({ type: SET_CANDIDATS_LOADING, payload: v });
export const setCandidatsError = (msg) => ({ type: SET_CANDIDATS_ERROR, payload: msg });

export const fetchCandidatsRequest = () => ({ type: FETCH_CANDIDATS_REQUEST });
export const fetchCandidatsSuccess = (data) => ({ type: FETCH_CANDIDATS_SUCCESS, payload: data });
export const fetchCandidatsFail = (err) => ({ type: FETCH_CANDIDATS_FAIL, payload: err });

export const createCandidatRequest = (payload) => ({ type: CREATE_CANDIDAT_REQUEST, payload });
export const createCandidatSuccess = (data) => ({ type: CREATE_CANDIDAT_SUCCESS, payload: data });
export const createCandidatFail = (err) => ({ type: CREATE_CANDIDAT_FAIL, payload: err });

export const updateCandidatRequest = (id, payload) => ({
    type: UPDATE_CANDIDAT_REQUEST,
    payload: { id, payload },
});
export const updateCandidatSuccess = (data) => ({ type: UPDATE_CANDIDAT_SUCCESS, payload: data });
export const updateCandidatFail = (err) => ({ type: UPDATE_CANDIDAT_FAIL, payload: err });

export const deleteCandidatRequest = (id) => ({ type: DELETE_CANDIDAT_REQUEST, payload: { id } });
export const deleteCandidatSuccess = (id) => ({ type: DELETE_CANDIDAT_SUCCESS, payload: id });
export const deleteCandidatFail = (err) => ({ type: DELETE_CANDIDAT_FAIL, payload: err });
